var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlytogetLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1511B",
    d: "M38.676 15.784h-5.071l-3.357-3.472c-1.003-1.036-2.16-1.327-3.198-1.327H11.513c-.86 0-1.906-.3-2.79-1.07l-1.26-1.227H30.06c1.68 0 2.696.284 4.02 1.808l4.596 5.288ZM4.596 5.29C5.92 6.812 6.935 7.097 8.615 7.097h22.598L29.95 5.868A4.303 4.303 0 0 0 27.163 4.8H11.625c-1.037 0-2.195-.291-3.198-1.328L5.071 0H0L4.596 5.29Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlytogetLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flytoget_logo.1f161f791c7faf055ee63c0cf7564c62.svg";